import React from 'react';

export interface ModalContextType {
  onClose: () => void;
}

const ModalContext = React.createContext<ModalContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose() {},
});

export default ModalContext;
